import FormControl from "common/components/FormControl/FormControl";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CrudForm from "common/components/Crud/CrudForm";
import OrganizationSelect from "components/select/OrganizationSelect/OrganizationSelect";
import type { Product } from "types";
import ColorSelect from "components/select/ColorSelect/ColorSelect";

type Props = {
  onSubmit: (values: any) => any;
  onCancel?: () => void;
  item?: Product;
};

function ProductForm({ onSubmit, onCancel, item }: Props) {
  const { t } = useTranslation();

  const initialValues = useMemo(
    () =>
      item?.id
        ? {
            ...item,
            organizations: item.organizations?.map((org) => org.id) || [],
            otherTagColor: !!item.tagColor && item.tagColor !== item.titleColor,
          }
        : {},
    [item],
  );

  return (
    <CrudForm
      onSubmit={onSubmit}
      onCancel={onCancel}
      initialValues={initialValues}
      headerIcon="BriefcaseIcon"
      i18nNamespace="products"
      render={(values, form) => (
        <div className="flex flex-col gap-4 white-box">
          <div className="flex flex-row gap-4">
            <FormControl
              name="image"
              titleKey="products.image"
              type="image"
              labelIcon="PhotoIcon"
              containerStyle="min-w-[200px]"
              className="border border-slate-200 rounded-lg overflow-hidden"
            />
            <div className="flex flex-col flex-1 gap-2">
              <FormControl
                name="name"
                type="richtext"
                title={t("products.name")}
                required
              />
              <FormControl
                name="description"
                title={t("products.description")}
                type="textarea"
              />
            </div>
          </div>
          <FormControl
            name="organizations"
            title={t("products.organizations")}
            type="custom"
            isSelect
          >
            <OrganizationSelect multiple />
          </FormControl>

          <FormControl
            name="titleColor"
            title={t("products.titleColor")}
            type="custom"
            containerStyle="w-full sm:w-3/4 md:w-2/3 lg:w-2/3"
          >
            <ColorSelect />
          </FormControl>

          <FormControl
            name="otherTagColor"
            type="checkbox"
            title={t("products.otherTagColor")}
            onChange={(val: any) => {
              if (!val) form.change("tagColor", null);
            }}
          />

          {Boolean(values?.otherTagColor) && (
            <FormControl
              name="tagColor"
              title={t("products.tagColor")}
              type="custom"
              containerStyle="w-full sm:w-3/4 md:w-2/3 lg:w-2/3"
            >
              <ColorSelect />
            </FormControl>
          )}
        </div>
      )}
    />
  );
}

export default ProductForm;
